import React, { useEffect } from 'react';
import { usePrivy } from '@privy-io/react-auth';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import ROUTES from '@/routers/Routes';
import { ReducerState } from '@/services/common/lib/reducerState';
import SplashScreen from '@/features/auth/components/SplashScreen/SplashScreen';
import AuthForm from './components/AuthForm';
import Modal from '@/components/Modal/Modal';
import useIsMobileView from '@/hooks/useIsMobileView';
import HeaderMobileDisplay from '@/components/header/views/HeaderMobileDisplay';

const Auth: React.FC = () => {
  const isMobileView = useIsMobileView();
  const { authenticated } = usePrivy();
  const userId = useSelector((state: ReducerState) => state.auth.id);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const referralCode = searchParams.get('referral') || searchParams.get('r');

  useEffect(() => {
    if (referralCode) {
      sessionStorage.setItem('referralCode', referralCode);
    }
  }, [referralCode]);

  if (authenticated && !!userId) {
    const redirectTo = location.state?.redirectTo || ROUTES.LOBBY;
    return <Navigate to={redirectTo} />;
  }

  return isMobileView ? (
    <div className="text-[16px]">
      <HeaderMobileDisplay.Container className="justify-center">
        <HeaderMobileDisplay.Logo />
      </HeaderMobileDisplay.Container>
      <div className="h-full p-4">
        <AuthForm />
      </div>
    </div>
  ) : (
    <SplashScreen>
      <Modal open={true}>
        <AuthForm />
      </Modal>
    </SplashScreen>
  );
};

export default Auth;
